import React from 'react';

import BaseIcon from '../BaseIcon';

const ReportAdd = (props) => (
    <BaseIcon {...props} viewBox="0 0 80 80">
        <path
            d="M66.4,78.71l-64.25,0c-1.33,-0.62 -1.73,-1.68 -1.72,-3.12c0.03,-19.32 0.03,-38.65 0,-57.97c0,-1.03 0.33,
            -1.82 1.07,-2.53c5.15,-4.88 10.29,-9.77 15.41,-14.68c0.72,-0.69 1.5,-0.99 2.49,-0.99c13.75,0.02 27.5,
            0.01 41.25,0.01c1.99,0 2.82,0.84 2.82,2.82c0,5.01 -0.01,10.01 -0.02,15.02c0,0.28 0,0.55 0,0.84c0.21,
            0.03 0.33,0.05 0.46,0.07c7.92,1.53 13.02,6.16 15.24,13.92c0.26,0.91 0.38,1.86 0.56,2.79l0,3.41c-0.05,
            0.14 -0.12,0.28 -0.14,0.43c-1.14,7.59 -5.31,12.73 -12.49,15.41c-1.15,0.43 -2.38,0.64 -3.58,0.96l0,4.25c0.69,
            0 1.33,0 1.97,0c1.77,0 2.65,0.88 2.65,2.67c0,4.56 -0.04,9.13 0.02,13.69c0.02,1.43 -0.42,2.44 -1.74,3.02l0,
            -0.02zm-7.61,-64.66l-37.59,0c0,0.91 0,1.76 0,2.61c0,1.88 -0.86,2.75 -2.73,2.75c-4.18,0 -8.36,0 -12.54,0c-0.27,
            0 -0.54,0 -0.79,0l0,54.6l49,0c0,-0.32 0,-0.6 0,-0.88c0,-3.77 0,-7.53 0,-11.3c0,-1.58 0.92,-2.49 2.5,-2.5c0.71,
            0 1.42,0 2.13,0l0,-4.3c-0.2,-0.05 -0.37,-0.11 -0.55,-0.15c-6.45,-1.15 -11.09,-4.7 -13.96,-10.58c-0.21,
            -0.43 -0.44,-0.6 -0.93,-0.59c-2.79,0.02 -5.57,0.01 -8.36,0.01c-3.07,0 -6.14,0.01 -9.21,0c-1.72,-0.01 -2.78,
            -1.47 -2.26,-3.05c0.34,-1.03 1.17,-1.57 2.48,-1.57c5.26,0 10.53,0 15.79,0c0.3,0 0.6,0 0.74,0c0.09,-2.26 0.18,
            -4.41 0.27,-6.62l-0.85,0c-5.19,0 -10.37,0 -15.56,0c-0.36,0 -0.73,0 -1.08,-0.06c-1.3,-0.2 -2.15,-1.45 -1.87,
            -2.73c0.27,-1.24 1.13,-1.85 2.65,-1.86c5.96,0 11.92,-0.01 17.88,0c0.56,0 0.86,-0.18 1.15,-0.66c2.51,
            -4.21 6.12,-7.05 10.83,-8.45c0.93,-0.28 1.89,-0.45 2.85,-0.68l0,-4l0.01,0.01zm2.17,36.36c7.92,0.05 14.06,
            -5.98 14.11,-13.85c0.04,-7.59 -6.16,-13.85 -13.78,-13.92c-7.7,-0.07 -14.06,6.18 -14.1,13.85c-0.04,7.75 6.02,
            13.88 13.78,13.93l-0.01,-0.01zm-2.16,-46.27l-37.56,0l0,5.16l37.55,0l0,-5.16l0.01,0zm4.62,69.9l0,-10l-4.57,0l0,
            10l4.57,0zm-54.78,-59.32l7.85,0l0,-7.48c-2.65,2.52 -5.2,4.95 -7.85,7.48z" transform="matrix(1 0 0 1 0 0)"
        />
        <path
            d="M32.57,50.37c2.14,0 4.28,0 6.42,0c1.55,0 2.55,0.9 2.57,2.29c0.02,1.4 -1.01,2.35 -2.58,2.36c-4.38,
            0 -8.77,0.01 -13.15,0c-1.79,0 -2.89,-1.55 -2.3,-3.15c0.35,-0.94 1.15,-1.48 2.31,-1.48c2.24,-0.01 4.49,
            0 6.73,0l0,-0.02z"
        />
        <path
            d="M30.01,61.66c1.39,0 2.79,-0.01 4.18,0c1.48,0.01 2.46,0.95 2.46,2.3c0,1.31 -0.97,2.31 -2.38,2.32c-2.84,
            0.04 -5.67,0.04 -8.51,0c-1.44,-0.02 -2.43,-1.07 -2.38,-2.4c0.05,-1.33 1.01,-2.21 2.46,-2.23c1.39,-0.01 2.78,
            0 4.18,0l-0.01,0.01z"
        />
        <path
            d="M16.4,43.72c-1.31,0.01 -2.31,-0.96 -2.33,-2.25c-0.03,-1.28 1.06,-2.38 2.33,-2.37c1.25,0.01 2.32,1.09 2.31,
            2.32c-0.01,1.3 -1,2.29 -2.3,2.3l-0.01,0z"
        />
        <path
            d="M16.41,50.38c1.25,0.02 2.31,1.09 2.29,2.33c-0.02,1.31 -1.09,2.34 -2.39,2.3c-1.29,-0.04 -2.26,-1.06 -2.24,
            -2.36c0.02,-1.25 1.09,-2.29 2.34,-2.27z"
        />
        <path
            d="M16.4,61.66c1.27,0 2.31,1.05 2.3,2.31c-0.01,1.28 -1.02,2.3 -2.3,2.31c-1.31,0.01 -2.34,-1.03 -2.33,
            -2.35c0.01,-1.26 1.06,-2.28 2.33,-2.27z"
        />
        <path 
            d="M16.4,32.45c-1.32,0 -2.32,-0.96 -2.33,-2.27c-0.02,-1.26 1.03,-2.32 2.3,-2.34c1.26,-0.01 2.34,1.05 2.34,
            2.3c0,1.3 -1,2.3 -2.31,2.31z"
        />
        <path
            d="M61.44,35.01c2.14,0 4.28,0 6.42,0c1.55,0 2.55,0.9 2.57,2.29c0.02,1.4 -1.01,2.35 -2.58,2.36c-4.38,0 -8.77,
            0.01 -13.15,0c-1.79,0 -2.89,-1.55 -2.3,-3.15c0.35,-0.94 1.15,-1.48 2.31,-1.48c2.24,-0.01 4.49,0 6.73,0l0,-0.02z"
        />
        <path
            d="M61.44,35.01c2.14,0 4.28,0 6.42,0c1.55,0 2.55,0.9 2.57,2.29c0.02,1.4 -1.01,2.35 -2.58,2.36c-4.38,0 -8.77,
            0.01 -13.15,0c-1.79,0 -2.89,-1.55 -2.3,-3.15c0.35,-0.94 1.15,-1.48 2.31,-1.48c2.24,-0.01 4.49,0 6.73,0l0,-0.02z"
            transform="rotate(90 61 37.3335)"
        />
    </BaseIcon>
);

export default ReportAdd;
